<template>
    <div class="form-container">
        <div class="form-item" v-if="showFields.includes('name')">
            <div class="form-content">
                <div class="label">姓名</div>
                <div class="content">
                    <input
                        :disabled="!!disabled"
                        @change="onValChange('name')"
                        v-model.trim="formData.name"
                        placeholder="请填写真实姓名"
                    />
                </div>
            </div>
            <div class="error-toast" v-if="error.name">请填写真实姓名</div>
        </div>
        <div class="form-item" v-if="showFields.includes('telNo')">
            <div class="form-content">
                <div class="label">手机号</div>
                <div class="content">
                    <input
                        :disabled="!!disabled"
                        type="text"
                        @change="onValChange('telNo')"
                        v-model.trim="formData.telNo"
                        placeholder="请填写有效的手机号"
                    />
                    <span class="unit">{{ formData.telNo.length || '' }}</span>
                </div>
            </div>
            <div class="error-toast" v-if="error.telNo">请填写有效的手机号</div>
        </div>
        <div class="form-item" v-if="showFields.includes('certNo')">
            <div class="form-content">
                <div class="label">证件类型</div>
                <div class="content">
                    <van-radio-group
                        :disabled="!!disabled"
                        v-model="formData.certType"
                        @change="formData.certNo = ''"
                        direction="horizontal"
                        icon-size="14px"
                    >
                        <van-radio checked-color="#07c160" name="idcard">身份证号</van-radio>
                        <van-radio checked-color="#07c160" name="passport">护照号</van-radio>
                    </van-radio-group>
                </div>
            </div>
        </div>
        <div class="form-item" v-if="showFields.includes('certNo')">
            <div class="form-content">
                <div class="label">{{ formData.certType === 'idcard' ? '身份证号' : '护照号' }}</div>
                <div class="content">
                    <input
                        :disabled="!!disabled"
                        @change="onValChange('certNo')"
                        v-model.trim="formData.certNo"
                        placeholder="请填写证件号"
                    />
                    <span class="unit">{{ formData.certNo.length || '' }}</span>
                </div>
            </div>
            <div class="error-toast" v-if="error.certNo">请填写正确证件号</div>
        </div>

        <div class="form-item" v-if="showFields.includes('address')">
            <div class="form-content">
                <div class="label">居住地址</div>
                <div class="content">
                    <input
                        :disabled="!!disabled"
                        @change="onValChange('address')"
                        v-model.trim="formData.address"
                        placeholder="请填写居住地址"
                    />
                </div>
            </div>
            <div class="error-toast" v-if="error.address">请填写居住地址</div>
        </div>
    </div>
</template>
<script>
import { RadioGroup, Radio } from 'vant'

export default {
    props: ['fieldList', 'disabled'],
    components: { VanRadioGroup: RadioGroup, VanRadio: Radio },
    watch: {
        fieldList: function () {
            this.initFields()
        },
    },
    data() {
        return {
            showFields: [],
            formData: {
                name: '',
                telNo: '',
                certType: 'idcard',
                certNo: '',
                address: '',
            },
            error: {
                name: false,
                telNo: false,
                certNo: false,
                address: false,
            },
        }
    },
    created() {
        this.initFields()
    },
    methods: {
        onValChange(key) {
            this.error[key] = !this.formData[key]
            if (key === 'telNo') {
                if (this.formData[key].startsWith('+')) {
                    // 如果以 '+' 开头，只校验是否是数字
                    this.error[key] = !/^\+\d+$/.test(this.formData[key])
                } else if (this.formData[key].startsWith('0')) {
                    // 以 '0' 开头，校验是否是 12 位固定电话
                    this.error[key] = !/^0\d{11}$/.test(this.formData[key])
                } else {
                    this.error[key] = !new RegExp(/^1[0-9]{10}$/).test(this.formData[key])
                }

            } else if (key === 'certNo' && this.formData.certType === 'idcard') {
                this.error[key] = !this.checkIdcard(this.formData.certNo)
            } else if (key === 'certNo' && this.formData.certType === 'passport') {
                this.error[key] = !this.checkpassport(this.formData.certNo)
            }
            return this.error[key]
        },

        // 校验参数
        validate() {
            const _params = {}

            let _state = true
            this.showFields.forEach((f) => {
                _params[f] = this.formData[f]
                if (this.onValChange(f)) {
                    _state = false
                }
            })

            return { state: _state, data: _params }
        },

        initFields() {
            const _showFields = []
            this.fieldList.forEach((i) => {
                _showFields.push(i.key)
                this.formData[i.key] = i.val
            })
            this.showFields = _showFields
        },
        checkIdcard(val) {
            const _p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            const _factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
            const _parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
            const _code = val.substring(17)
            if (_p.test(val)) {
                var sum = 0
                for (var i = 0; i < 17; i++) {
                    sum += val[i] * _factor[i]
                }
                if (_parity[sum % 11] == _code.toUpperCase()) {
                    return true
                }
            }
            return false
        },
        checkpassport(val) {
            const _regex = /^[a-zA-Z0-9]+$/
            return _regex.test(val)
        },
    },
}
</script>
<style lang="scss" scoped>
.form-container {
    max-width: 540px;
    margin: 28px auto 0;
    .form-item {
        padding: 0 16px;
        font-size: 14px;
        min-height: 44px;
        border-bottom: 1px solid #eee;
        .form-content {
            display: flex;
        }
        .error-toast {
            color: #f00;
            margin-left: 76px;
            padding: 6px 12px;
            font-size: 12px;
        }
        .label {
            text-align-last: justify;
            padding: 0 10px;
            color: #999;
            width: 60px;
            flex-shrink: 0;
            line-height: 44px;
            margin-right: 6px;
        }
        .content {
            flex-grow: 1;
            min-height: 44px;
            position: relative;
        }
        input {
            width: 100%;
            height: 44px;
            border: none;
        }
        input:disabled {
            background: inherit;
        }
        .van-radio-group {
            height: 44px;
            margin-left: 5px;
            color: #666;
        }
        .unit {
            font-size: 12px;
            color: #999;
            position: absolute;
            right: 24px;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}
</style>
